import type { ScopeHrefFor } from './scope.types';

/**
 * Addresses a region as `?region=<slug>` on the given page, at any depth. The
 * endpoints behind these pages take one slug and roll up everything beneath it.
 */
export function queryRegionHref(basePath: string): ScopeHrefFor {
  return (region) => (region ? `${basePath}?region=${encodeURIComponent(region.slug)}` : basePath);
}
